import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import PulseLoader from 'react-spinners/PulseLoader';

// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
  display: block;
  margin: 0 auto;
`;

const Loader = ({loading=true}) => {
  return (
    <PulseLoader
      size={15}
      margin={15}
      css={override}
      loading={loading}
      color={'#21bfaf'}
    />
  );
};

Loader.propTypes = {
  loading: PropTypes.bool
};

export default Loader;
